import _ from "underscore";
import ShoppingCartItem from '../models/ShoppingCartItem';

const KEY_SHOPPING_CART = "cart";

class DataStore {

    getAttributeByName(name) {
        var ret = this.getAttributesWhere({
            name: name
        });
        if (ret.length > 0) {
            return ret[0];
        }
        return ret;
    }

    getAttributeByOption(option) {
        for (var attribute of this.getObject("attributes")) {
            if (_.contains(attribute.options, option)) {
                return attribute;
            }
        }

    }

    getAttributesWhere(where) {
        return this.getWhere("attributes", where);
    }

    getUser() {
        return this.getObject("currentUser");
    }

    saveUser(user) {
        this.setObject("currentUser", user);
    }

    clearUser() {
        this.set("currentUser", null);
    }

    getShoppingCart() {
        let cartItems = [];
        let cart = this.getObject(KEY_SHOPPING_CART) || [];
        cart.forEach(item => {
            let cartItem = new ShoppingCartItem();
            Object.assign(cartItem, item);
            cartItem.total = cartItem.getTotal();
            cartItems.push(cartItem);
        });
        return cartItems;
    }

    saveShoppingCart(cart) {
        this.setObject(KEY_SHOPPING_CART, cart);
    }

    clearShoppingCart() {
        this.set(KEY_SHOPPING_CART, null);
    }

    saveUserSurvey(answers) {
        this.setObject("survey", answers);
    }

    getUserSurvey() {
        return this.getObject("survey");
    }

    getWhere(set, where) {
        return _.where(this.getObject(set), where);
    }

    setObject(key, obj) {
        this.set(key, JSON.stringify(obj));
    }

    getObject(key) {
        var ret = this.get(key);
        if (!ret) {
            return false;
        }
        return JSON.parse(ret);
    }

    set(key, value) {
        localStorage.setItem(key, value);
    }

    get(key) {
        return localStorage.getItem(key)
    }

    clear() {
        localStorage.clear();
    }

}

export default DataStore;



// WEBPACK FOOTER //
// ./src/api/DataStore.js